import React, { useEffect } from 'react';

import OutageBlock from '../common/OutageBlock';
import { STATS_EVENTS, sendStats } from '../../../../helpers/sendStats';

// typograf-enable
export default function NoOutage() {
  useEffect(function sendStatsOnMount() {
    sendStats(STATS_EVENTS.HAS_HOT_WATER);
  }, []);

  return <OutageBlock heading="В вашем доме планового отключения горячей воды не будет" />;
}
